import { Modal } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import { SurveyCreatorComponent, SurveyCreator } from 'survey-creator-react';
import { editorLocalization } from 'survey-creator-core';
import ButtonComp from '@components/UI/Button/Index.jsx';
import { customTheme } from "@styles/survey-ui/survey-custom-theme";
import 'survey-creator-core/i18n/portuguese';
import 'survey-core/i18n/portuguese';
import 'survey-core/survey-core.css';
import 'survey-creator-core/survey-creator-core.css';
import { surveyLocalization } from "survey-core";
import { CustomLoader } from '@components/UI/CustomLoader/Index';
import { modifyFieldsStructureInSurveyJson } from '@utils/surveyJS/surveyStoreJson';

surveyLocalization.defaultLocale = "pt";
editorLocalization.currentLocale = 'pt';

const SurveyCreatorModal = ({ open, onClose, onSave, initialJson = {} }) => {
  const [editorReady, setEditorReady] = useState(false);

  const creator = useMemo(() => {
    const surveyCreator = new SurveyCreator();
    surveyCreator.applyCreatorTheme(customTheme);
    surveyLocalization.locales["pt"].completeText = "Salvar Respostas";
    surveyCreator.saveSurveyFunc = (saveNo, callback) => {
      const json = modifyFieldsStructureInSurveyJson(surveyCreator.JSON);
      onSave(json);
      callback();
    };
    return surveyCreator;
  }, [onSave]);

  useEffect(() => {
    if (open) {
      setEditorReady(false);
      setTimeout(() => {
        creator.JSON = initialJson;
        setEditorReady(true);
      }, 50); // Pequeno delay para garantir montagem
    }
  }, [initialJson, creator, open]);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      getContainer={false}
      footer={null}
      width="70%"
      title="Modal de Formulário Personalizado"
      destroyOnClose={false}
    >
      <div style={{ maxHeight: '70vh', overflowY: 'auto' }}>
        {editorReady ? (
          <SurveyCreatorComponent creator={creator} />
        ) : (
          <CustomLoader text={"Carregando os dados..."} />
        )}
      </div>

      <div className="d-flex justify-content-end mt-3 gap-2">
        <ButtonComp
          title="SALVAR E FECHAR"
          type="button"
          buttonColor="#2b97be"
          onClick={() => creator.saveSurvey()}
          classnameIcon={"fa-regular fa-floppy-disk"}
          hoverMessage={"Botão para salvar as alterações"}
        />
        <ButtonComp
          title="CANCELAR"
          type="button"
          buttonColor="#dc3545"
          onClick={onClose}
          classnameIcon="fa-regular fa-circle-xmark"
          hoverMessage={"Botão para fechar o modal"}
        />
      </div>
    </Modal>
  );
};

export default SurveyCreatorModal;
